/** Mirrors PrawkoApi InternalExamSessionMode: 0 = Exam, 1 = Lectures. */
export type InternalExamSessionMode = 'exam' | 'lectures';

export const INTERNAL_EXAM_SESSION_MODE_VALUES: Record<
  InternalExamSessionMode,
  number
> = {
  exam: 0,
  lectures: 1,
};

export interface InternalExamDeviceVm {
  guid: string;
  name: string;
  tokenExpiresAtUtc: string;
  lastSeenAtUtc: string;
  online: boolean;
  hasActiveSession: boolean;
  /** Numeric InternalExamSessionMode of the running session, null when the device is free. */
  activeSessionMode: number | null;
}

/** POST /InternalExamPairingApproval: the station that the confirmed code belongs to. */
export interface InternalExamPairingApprovalVm {
  deviceName: string;
  /** The station was already registered for this OSK and keeps its name. */
  isExistingDevice: boolean;
}

export interface InternalExamLaunchVm {
  sessionGuid: string;
  deviceGuid: string;
  expiresAtUtc: string;
}

/**
 * Who sits down at the station: one student (exam or lectures) or a whole lecture group
 * (lectures only). Exactly one of the guids is set.
 */
export interface InternalExamLaunchTarget {
  studentGuid?: string;
  lectureGroupGuid?: string;
}

export interface InternalExamHandoffVm {
  sessionGuid: string;
  handoffCode: string;
  expiresAtUtc: string;
}
